export const locales = {
    "no": {
        "header": "Start miljøer",
        "uptime-1h": "1 time",
        "uptime-2h": "2 timer",
        "uptime-4h": "4 timer",
        "uptime-8h": "8 timer"
    }
};